module.exports = __webpack_public_path__ + "edbdf1e5f565f483b9f11a0c424d7b50.png";